export function isNumeric(value) {
  if (value === null || value === undefined || value === "") return false;

  // Convert to string for pattern matching
  const strValue = String(value);

  // Check if it looks like a date in format DD.MM or MM.DD
  const datePattern =
    /^(0?[1-9]|[12][0-9]|3[01])\.(0?[1-9]|1[0-2])$|^(0?[1-9]|1[0-2])\.(0?[1-9]|[12][0-9]|3[01])$/;
  if (datePattern.test(strValue)) {
    return false;
  }

  // Also exclude values that could be dates in YYYY.MM.DD format
  const fullDatePattern = /^\d{4}\.\d{1,2}\.\d{1,2}$|^\d{1,2}\.\d{1,2}\.\d{4}$/;
  if (fullDatePattern.test(strValue)) {
    return false;
  }

  const num = parseFloat(value);
  return (
    !isNaN(num) &&
    !isValidMobilePhoneNumber(strValue) &&
    // Exclude values that look like years or IDs
    !(strValue.length === 4 && num >= 2000 && num <= 2050) &&
    // Include only values that are likely to be financial amounts
    ((num >= 100 && num % 1 === 0) || num % 1 !== 0)
  );
}

export function roundToTwoDecimals(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}

export function isValidMobilePhoneNumber(phoneNumber) {
  return /^(\+?385)?(0?9[125789])\d{6,7}$/.test(phoneNumber);
}
